import React from "react";
import { Instagram, Music2, Youtube, Twitter } from "lucide-react";

const ICONS = {
  instagram: Instagram,
  tiktok: Music2,
  youtube: Youtube,
  twitter: Twitter,
};

export default function SocialIcons({ socials, size = 18, className = "", itemClassName = "", testidPrefix = "social" }) {
  return (
    <div className={`flex items-center ${className}`}>
      {socials.map((s) => {
        const Icon = ICONS[s.type] || Instagram;
        return (
          <a
            key={s.type}
            href={s.url}
            aria-label={s.type}
            data-testid={`${testidPrefix}-${s.type}`}
            className={`text-white/60 transition-colors hover:text-white ${itemClassName}`}
          >
            <Icon size={size} strokeWidth={1.4} />
          </a>
        );
      })}
    </div>
  );
}
